import mixpanel from "mixpanel-browser";
import { useEffect } from "react";

import { useIsAdmin } from "../api/user-auths/is-admin";
import { useLoggedInUser } from "../api/user-auths/login";
import { mpLogin, mpViewPage } from "../utils/mixpanel";

export const useViewPage = (page: string) => {
  useEffect(() => {
    mpViewPage(page);
  }, []);
};

export const useViewAnalyticsPage = (page: string) => {
  useEffect(() => {
    mpViewPage(page);
  }, [page]);
};

export const useMixpanelLogin = () => {
  const user = useLoggedInUser();
  const isAdmin = useIsAdmin();

  useEffect(() => {
    if (user.isSuccess) {
      mpLogin(user.data);
    }
  }, [user.data?.user?.id, user.isSuccess]);

  // useEffect(() => {
  //   if (!user.isSuccess || isAdmin === undefined) return;
  //
  //   if (!isAdmin) {
  //     mixpanel.start_session_recording();
  //   }
  // }, [user.isSuccess, user.data?.user?.id, isAdmin]);
};
